import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { PackageX } from "lucide-react";

export default function StockAlert() {
  const { isAdmin, isSuperAdmin } = useAuth();
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  useEffect(() => { if (isAdmin) { api.get("/bar-stock-alerts").then((r) => setItems(r.data)).catch(() => {}); } }, [isAdmin]);
  if (!items.length) return null;
  return (
    <div className="mb-6 p-4 rounded-xl border border-orange-200 bg-orange-50" data-testid="stock-alert">
      <div className="flex items-center gap-2 font-semibold text-orange-800 mb-2"><PackageX size={16} /> Bar e gadget: scorte sotto il 20%</div>
      <div className="flex flex-wrap gap-2">
        {items.map((i) => (
          <span key={i.id} className="text-sm px-2.5 py-1 rounded-full bg-white border border-orange-200 text-orange-900" data-testid={`stock-alert-${i.id}`}>
            {i.name}: <b>{i.stock}</b> rimasti su {i.last_load}
          </span>
        ))}
      </div>
      {isSuperAdmin && <button onClick={() => navigate("/bar")} className="mt-2 py-1 text-xs font-semibold text-orange-800 hover:underline" data-testid="stock-alert-open">Apri Bar e gadget → Listino prezzi per ricaricare</button>}
    </div>
  );
}
